export default __webpack_public_path__ + "static/media/casilla50.6b1aea65.png";